import { jsxs, jsx } from "react/jsx-runtime";
import { Wrapper, Option } from "./QuickFilter.styles.js";
import "@mui/material";
import "@mui/material/styles";
const QuickFilter = ({ onJumpMonths, onReset, labels }) => {
  const handleOptionClick = (months) => () => onJumpMonths(months);
  return /* @__PURE__ */ jsxs(Wrapper, { children: [
    /* @__PURE__ */ jsx(Option, { onClick: onReset, children: labels.quickFilterToday }),
    /* @__PURE__ */ jsx(Option, { onClick: handleOptionClick(6), children: labels.quickFilterSixMonths }),
    /* @__PURE__ */ jsx(Option, { onClick: handleOptionClick(12), children: labels.quickFilterOneYear })
  ] });
};
export {
  QuickFilter as default
};
